export enum UPLOAD_STATUS{
    not_started = 'not_started',
    started = 'started',
    completed = 'completed',
    failed = 'failed',
    processed = 'processed'
}